import { createFileRoute, useParams } from '@tanstack/react-router';
import { MyCertificationDetailContent, useGetMyHandlingCertificationDetail } from '../../../../-shared';
export const Route = createFileRoute('/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/')({
  component: MyHandlingCertificationDetail
});
function MyHandlingCertificationDetail() {
  const {
    id
  } = useParams({
    from: '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/'
  });
  const queryResult = useGetMyHandlingCertificationDetail(id);
  return <MyCertificationDetailContent {...queryResult} />;
}